import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import HomePage from "./components/view/HomePage/HomePage.jsx";
import Mechanic from "./components/view/Mechanic/components/Mechanic.jsx";
import Vulcanization from "./components/view/Vulcanization/components/Vulcanization.jsx";
import NotFound from "./components/view/Error/404.jsx";

function App() {

  // useEffect(() => {
  //   console.log("Public Key:", process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  // }, []);

  // const [cookieSettings, setCookieSettings] = useState({
  //   analytics: false,
  //   marketing: false
  // });
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/mechanic" element={<Mechanic />} />
        <Route path="/vulcanization" element={<Vulcanization />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
